export default "__VITE_ASSET__iAyloVPB__"